import React, { useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { AppBar, Toolbar } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: "none",
  },
  mainIframe: {
    zIndex: 100,
  },
  topBar4: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "60px !important",
      display: "block !important",
    },
  },
}));

const Topbar = (props) => {
  const { className, headerData, ...rest } = props;

  const getGeneratedPageURL = ({ html, css, js }) => {
    const getBlobURL = (code, type) => {
      const blob = new Blob([code], { type });
      return URL.createObjectURL(blob);
    };

    const cssURL = getBlobURL(css, "text/css");
    const jsURL = getBlobURL(js, "text/javascript");

    const source = `
      <html>
        <head>
          ${css && `<link rel="stylesheet" type="text/css" href="${cssURL}" />`}
          ${js && `<script src="${jsURL}"></script>`}
        </head>
        <body>
          ${html || ""}
        </body>
      </html>
    `;

    return getBlobURL(source, "text/html");
  };

  const html = headerData && headerData.html;

  const url = getGeneratedPageURL({
    html: html,
    css: "",
    js: "",
  });

  const classes = useStyles();
  return (
    <div
      className={classes.topBar4}
      dangerouslySetInnerHTML={{ __html: html }}
    ></div>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
};

export default Topbar;
